<template>
  <SnackBar ref="snackbar" />
  <v-container fluid>
    <div class="flex-title">
      <v-btn
        style="background: #f9f8f8; font-size: 18px"
        size="small"
        @click="this.$router.go(-1)"
        icon
      >
        <v-icon color="#004984">mdi-arrow-left</v-icon>
      </v-btn>
      <v-skeleton-loader
        class="skeleton-wrapper sprint-text"
        type="text"
        :loading="isLoading"
        v-if="isLoading"
      ></v-skeleton-loader>
      <h1 class="task-title" v-else>
        Gráfico do Status das Tarefas da Sprint -
        <span>{{ nomeProjeto }}</span> <v-icon>mdi-chart-bar</v-icon>
      </h1>
    </div>
    <v-divider class="mx-4" inset vertical></v-divider>
    <v-row>
      <v-col cols="6">
        <v-card flat color="transparent">
          <div class="flex">
            <v-card-title class="task-card-title">
              Acompanhe os status das tarefas da sprint:
            </v-card-title>
            <v-select
              :no-data-text="'Ainda não há sprints a serem exibidos.'"
              v-model="sprintsSelecionada"
              :items="
                sprints.map((sprint) => ({
                  title: sprint.titulomilestone,
                  value: sprint.id_sprint,
                }))
              "
              variant="underlined"
              hint="Selecione uma sprint"
              persistent-hint="Selecione uma sprint"
              return-object
            ></v-select>
            <!-- <p>
              Valores selecionados: {{ sprintsSelecionada }}, tipo:
              {{ typeof sprintsSelecionada }}
            </p> -->
          </div>
        </v-card>
      </v-col>
    </v-row>

    <div v-if="!isLoading">
      <bar-chart
        class="bar-chart"
        :dados="dadosGrafico"
        :titulo="`Quantidade`"
        :cor="`#db8234`"
      ></bar-chart>
    </div>
  </v-container>
</template>

<script>
import axios from 'axios';
import { VSkeletonLoader } from 'vuetify/labs/VSkeletonLoader';

import BarChart from '@/components/BarChart.vue';
import SnackBar from '@/components/SnackBar.vue';
import store from '@/store/store';

const API_URL = process.env.VUE_APP_API_URL || 'http://localhost:3000';

export default {
  components: {
    SnackBar,
    VSkeletonLoader,
    BarChart,
  },
  data() {
    return {
      idProjeto: null,
      isLoading: true,
      sprints: [],
      sprintsSelecionada: null,
      dadosGrafico: [],
      dados: [],
    };
  },
  watch: {
    sprintsSelecionada(newVal) {
      if (newVal) {
        const sprint = this.dados.find(
          (sprint) => sprint.id_sprint === newVal.value,
        );

        if (sprint) {
          this.dadosGrafico = sprint.tarefas;
        }
      }
    },
  },
  created() {
    this.fetchSprint(this.$route.params.id);
    this.fetchGraficoTarefasBacklog(this.$route.params.id);
  },
  methods: {
    fetchSprint(idProjeto) {
      axios
        .get(API_URL + `/sprints/projeto/${idProjeto}`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          this.sprints = response.data;
        })
        .catch((error) => {
          console.error(error);
        });
    },
    fetchGraficoTarefasBacklog(idProjeto) {
      axios
        .get(API_URL + `/sprints/${idProjeto}/backlogsprintstatus`, {
          headers: {
            Authorization: `Bearer ${store.state.token}`,
          },
        })
        .then((response) => {
          this.dados = response.data.dados;
          this.nomeProjeto = response.data.projeto;
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          console.error(error);
        });
    },
  },
};
</script>

<style scoped>
.task-title {
  font-size: 22px;
  font-weight: bold;
}
.flex-title {
  display: flex;
  align-items: center;
  gap: 10px;
}
.skeleton-wrapper {
  width: 50%;
  background: transparent;
}
.sprint-text {
  font-size: 22px;
  font-weight: bold;
}
.line-chart {
  height: 68vh;
}
.task-card-title {
  font-size: 16px;
  margin-bottom: 10px;
}
.flex {
  display: flex;
}
.bar-chart {
  height: 68vh;
}
</style>
